/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectContentById } from '../storage/contents';

/* Utils */
import { PROVIDERS } from '../utils/constants';

const fullPatternRegex = /^[\dA-Fa-f-]{36}.+/;
const uuidRegex = /^[\dA-Fa-f-]{36}/;

export default function useContent(contentId, sourceProvider = PROVIDERS.VRIO) {
  const formattedContentId = useMemo(() => {
    if (!contentId) {
      return '';
    }

    if (fullPatternRegex.test(contentId)) {
      return contentId;
    }

    const cleanContentId = contentId?.match(uuidRegex)?.[0] ?? contentId;

    return `${cleanContentId}-${sourceProvider}`;
  }, [contentId, sourceProvider]);

  const contentSelector = useMemo(
    () => selectContentById(formattedContentId),
    [formattedContentId],
  );

  return useSelector(contentSelector);
}
